import styled from 'styled-components';

const IAgreeContainerMobile = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
    padding: 1rem;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.101025);
    z-index: 2;
    position: absolute;
    background: #f5f6f8;
  }
`;

const IAgreeContainerDesktop = styled.span`
  display: none;

  @media only screen and (min-width: 768px) {
    display: block;
    width: fit-content;
    margin-left: auto;
  }
`;
const IAgreeText = ({ t, isMobile = false }) => {
  return isMobile ? (
    <IAgreeContainerMobile>
      <span className="info">
        {t('Almost done. I agree to be legally bound by this document and the')}{' '}
        <a
          href="https://jetpackapps.co/getsign-terms-of-use/"
          target="_blank"
          rel="noreferrer"
        >
          {t('Terms of Service')}
        </a>
        . {t('Click on ‘I Agree’ to sign this document')}.
      </span>
    </IAgreeContainerMobile>
  ) : (
    <IAgreeContainerDesktop>
      <span className="info">
        {t('Almost done. I agree to be legally bound by this document and the')}{' '}
        <a
          href="https://jetpackapps.co/getsign-terms-of-use/"
          target="_blank"
          rel="noreferrer"
        >
          {t('Terms of Service')}
        </a>
        . {t('Click on ‘I Agree’ to sign this document')}.
      </span>
    </IAgreeContainerDesktop>
  );
};

export default IAgreeText;
